import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function ButtonAppBar() {
  const classes = useStyles();

  const preventDefault = (event) => event.preventDefault();

  return (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ backgroundColor: "#181818" }}>
        <Toolbar>
          <Button className="NavBtn">
            <Link className="NavLink" to="/latest">
              latest
            </Link>
          </Button>
          <Typography variant="h6">SpaceX Launches</Typography>
          <Button className="NavBtn">
            <Link className="NavLink" to="/past">
              all
            </Link>
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}
